import {loader} from '@monaco-editor/react'
import * as monaco from 'monaco-editor'

// Wire the React wrapper to the locally bundled monaco-editor package instead of
// the default CDN loader (https://cdn.jsdelivr.net/...). Both build modes ship
// monaco in the chunk already; CDN fetches add latency in real mode and fail
// outright in mock mode where the prebuilt bundle is served by serve-mock.mjs
// without any CDN passthrough. Calling loader.config({monaco}) once at module
// load short-circuits the AMD bootstrap so editor mounts resolve synchronously
// against the bundled instance.
loader.config({monaco})

// The AMD loader exposed `window.monaco` as a side effect; the bundled path
// does not. Keep that contract so e2e helpers (typeInMonaco, etc.) can reach
// the active editors via window.monaco.editor.getEditors().
;(window as unknown as Record<string, unknown>).monaco = monaco
